
/* Advance Livefyre integration: Main */
ADILF.require(['config'], function(config) {
    "use strict";
    if (typeof window.console == "undefined" || typeof window.console.log == "undefined" || typeof window.console.warn == "undefined" || typeof window.console.debug == "undefined" || typeof window.console.info == "undefined") { window.console = { log:function(){}, info:function(){}, debug:function(){}, warn:function(){} }; }
    if (!window.Advance) window.Advance = {};
    if (!window.Advance.Social) {
        window.Advance.Social = {};
    }
    ADILF.require(['adilf/context', 'adilf/debug'], function(Context, Debug) {

        var runtime = {
            adiHost: function() {
                return "static" + Context.getTier().envSuffix + ".advance.net";
            }
        };

        // Set appropriate js source for tier
        ADILF.require.config({
            paths: {
                'livefyre/livefyre-js': 'https://cdn.livefyre.com/Livefyre',
                'adi-fed/gigya': 'https://' + runtime.adiHost() + '/static/common/js/adv_gigya'
            }
        });
        if (typeof window.Advance.Gigya === 'object') {
            ADILF.define('adi-fed/gigya', [], function() { return window.Advance.Gigya; });
        }
        if (typeof window.Livefyre === 'object') {
            ADILF.define('livefyre/livefyre-js', [], function() { return window.Livefyre; });
        }

        // Moving this down here so runtime config doesn't get overwritten by a second load :|
        if(window.Advance.Social.debug) {
            console.warn("Thwarted attempted double load of ADI Livefyre");
            return;
        }

        Advance.Social.debug = new Debug();

        // Load use case script, 'data-start' attribute on #adilf script tag
        ADILF.require(['adilf/util/page-loader', 'livefyre/livefyre-js'], function(loader, LF) {
            LF.on('beforeLoadPermalinks', function (e) {
                // Disable the Permalink Modal
                e.disableModal();
            });
            LF.require(['auth'], function(auth) {
                loader.autoLoad();
            });
        });

    });

});
ADILF.define('adilf', ['adilf/adilf'], function (main) { return main; });

ADILF.define("adilf/adilf", function(){});
